import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { dark } from '../theme';
import responsive, { breakpoint } from '../utils/responsive';
import { H4, Text } from './typography';
import ContactForm from '../forms/ContactForm';
import { PlainLink } from './NavLink';
import Icon from './Icon';
import theme from '../theme';
import { TrianglesTopRight } from './Triangles';
import { withLanguage } from './i18n/LanguageContext';

const FooterContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 101vh;
  background: ${theme.colors.primary.darken(0.4).toHex()};

  display: grid;
  justify-content: stretch;
  align-items: stretch;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-template-rows: min-content auto;
  grid-gap: 2em;

  ${responsive.md.andSmaller`
    grid-gap: 0;
    font-size: 1em;
    grid-template-rows: min-content 2fr 1fr;
    grid-template-columns: minmax(0, 1fr);
  `}

  > iframe {
    width: 100%;
    margin: 2em;
    height: auto;
    grid-column: 1;
    border: 2px solid white;

    ${responsive.md.andSmaller`
      margin: 2em 0;
      grid-column: 1;
      width: auto;
    `}
  }
`;

const ContactContainer = styled.div`
  background: ${theme.colors.primary.toHex()};
  display: flex;
  justify-content: center;
  padding: 1em 2em;
  height: 10em;
  align-items: center;
  flex-direction: column;
  > h4 {
    text-transform: uppercase;
    ${responsive.sm.andSmaller`
      font-size: 1em;
    `}
    margin: 0;
    margin-bottom: 1em;
  }
  grid-column: 1 / span 2;

  border-bottom: 2px solid white;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2em;
  justify-content: flex-end;
  > span {
    display: flex;
    align-items: center;
    margin-top: 0.6em;
    > i {
      margin-right: 0.5em;
    }
  }

  ${responsive.md.andSmaller`
      font-size: 1em;
      grid-column: 1 / span 2;
  `}
`;

const Footer = ({ content: { info, general } }) => (
  <ThemeProvider theme={dark}>
    <FooterContainer id={'footer'}>
      <ContactContainer>
        <H4>{general.contactForm.explanation}</H4>
        <ContactForm {...general.contactForm} />
      </ContactContainer>
      <iframe
        title={'gmap'}
        frameBorder="0"
        src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJh9iRbqLVTRMRmWEi7rdaKGE&zoom=13&key=AIzaSyC_XCeIngWm-SUwLQ7gIYf4CCNiIbwEdH4"
        allowFullScreen
      />
      <Info>
        <span>
          <Icon m>place</Icon>
          <Text>La Villa Boutique Hotel & Restaurant</Text>
        </span>
        <span>
          <Icon m>map</Icon>
          <Text>Cara Dušana 2, Budva 85310, Montenegro</Text>
        </span>
        <span>
          <Icon m>phone</Icon>
          <PlainLink href={`tel:${info.tel}`} className={'plain'}>
            {info.tel}
          </PlainLink>
        </span>
        <span>
          <Icon m>mail_outline</Icon>
          <PlainLink href={`mailto:${info.mail}`} className={'plain'}>
            {info.mail}
          </PlainLink>
        </span>
        {window.innerWidth > breakpoint.md && (
          <TrianglesTopRight
            style={{
              zIndex: 0,
              top: '10em',
              width: '35%',
              opacity: 0.2,
            }}
          />
        )}
      </Info>
    </FooterContainer>
  </ThemeProvider>
);

export default withLanguage(Footer);
